import { useEffect } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { browserLogger } from '../../utils/loggers/browser';
export type ExecuteRecaptcha = (action?: string) => Promise<string>;
interface RecaptchaV3ControllerProps {
  enabled: boolean;
  siteKey?: string;
  onExecuteRecaptchaChange: (executeRecaptcha: ExecuteRecaptcha | undefined) => void;
}
const RecaptchaV3ExecutionBridge = ({
  onExecuteRecaptchaChange
}: Pick<RecaptchaV3ControllerProps, 'onExecuteRecaptchaChange'>) => {
  const {
    executeRecaptcha
  } = useGoogleReCaptcha();
  useEffect(() => {
    onExecuteRecaptchaChange(executeRecaptcha);
    return () => onExecuteRecaptchaChange(undefined);
  }, [executeRecaptcha, onExecuteRecaptchaChange]);
  return null;
};
export const RecaptchaV3Controller = ({
  enabled,
  siteKey,
  onExecuteRecaptchaChange
}: RecaptchaV3ControllerProps) => {
  useEffect(() => {
    if (enabled && !siteKey) {
      browserLogger({
        level: 'error',
        team: 'client-onboarding',
        feature: 'email-login',
        message: 'reCAPTCHA v3 enabled without a site key'
      });
    }
  }, [enabled, siteKey]);
  if (!enabled || !siteKey) return null;
  return <GoogleReCaptchaProvider reCaptchaKey={siteKey} useEnterprise>
      <RecaptchaV3ExecutionBridge onExecuteRecaptchaChange={onExecuteRecaptchaChange} />
    </GoogleReCaptchaProvider>;
};